//import objectFitImages from 'object-fit-images'
import smoothscrollPolyfill from 'smoothscroll-polyfill';
import intersectionObserver from 'intersection-observer';
import whatInput from 'what-input';

import {changeImg} from "../modules/changeImg";
import {smoothScrollVanilla} from "../modules/smoothScrollVanilla";
//import {smoothLink} from "../modules/smoothLink";
//import {pagetop} from "../modules/pagetop";
//import {scrollAnimation} from "../modules/scrollAnimation";
//import {nav} from "../modules/nav";

//import {accordion} from "../modules/accordion";
//import {headerFixed} from "../modules/headerFixed";
//import {scrollCv} from "../modules/scrollCv";
//import {tab} from "../modules/tab";


//import {swiper} from "../modules/swiper";
//import {instagram} from "../modules/instagram";

//objectFitImages();
smoothscrollPolyfill.polyfill();
whatInput.ask();

changeImg();
smoothScrollVanilla();
//smoothLink();
//pagetop();
//scrollAnimation();
//nav();

//accordion();
//headerFixed();
//scrollCv();
// tab();

//swiper();
// instagram();
